import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Material
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  MatPaginatorModule,
  MatPaginatorIntl
} from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';

// 3rd libraries
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { NgxSpinnerModule } from 'ngx-spinner';

// Components
import { LoaderComponent } from './components/loader/loader.component';

// Utils
import { CustomPaginator } from './lib/custom-paginator';

const ANGULAR_MODULES = [CommonModule, ReactiveFormsModule, FormsModule];

const MATERIAL_MODULES = [
  MatButtonModule,
  MatCardModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatToolbarModule
];

const THIRD_PARTY_LIBRARY = [NgxSpinnerModule, MaterialFileInputModule];

const PUBLIC_COMPONENTS = [LoaderComponent];

export const DATE_FORMAT = 'DD/MM/YYYY';
export const MY_FORMATS = {
  parse: {
    dateInput: DATE_FORMAT
  },
  display: {
    dateInput: DATE_FORMAT,
    monthYearLabel: 'MMMM YYYY'
  }
};

@NgModule({
  declarations: [...PUBLIC_COMPONENTS],
  imports: [...ANGULAR_MODULES, ...MATERIAL_MODULES, ...THIRD_PARTY_LIBRARY],
  exports: [
    ...ANGULAR_MODULES,
    ...MATERIAL_MODULES,
    ...PUBLIC_COMPONENTS,
    ...THIRD_PARTY_LIBRARY
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: CustomPaginator
    },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'es-SP' },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class SharedModule {}
